import { message } from 'antd';
import { isImageFile, isVideoFile, blobToFile, dataURItoBlob, dataURLtoFile } from 'common/utils';

export function base64StringtoFile(base64String: string, filename: string = 'image.jpg', type: string = 'image/jpeg') {
  const str = base64String.split(',').pop();
  if (str) {
    const bstr = window.atob(str);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, {
      type,
    });
  } else {
    return null;
  }
}

export function checkFileIsImage(file: File) {
  return (
    file.type === 'image/png' || file.type === 'image/jpeg'
    // file.type === 'image/gif' ||
    // file.type === 'image/tiff' ||
    // file.type === 'image/bmp' ||
    // file.type === 'image/x-icon' ||
    // file.type === 'image/webp'
  );
}

export function convertFileToBase64(file: File) {
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      resolve(reader.result as string);
    };
    reader.onerror = (error) => {
      reject(error);
    };
  });
}

export function revokeDownload(url: string) {
  if (!url) {
    message.error('下载url不能为空');
    return;
  }
  const eleLink = document.createElement('a');
  eleLink.style.display = 'none';
  eleLink.href = url;
  document.body.appendChild(eleLink);
  eleLink.click();
  document.body.removeChild(eleLink);
}

export const byteToMB = (size: string) => (Number(size) / 1024 / 1024).toFixed(2);

// TODO: 保持原有的引用来源，后续可重构业务代码中的引用，并将此处转发一并移除
export { isImageFile, isVideoFile, blobToFile, dataURItoBlob, dataURLtoFile };
